module.exports = __webpack_public_path__ + "static/media/alert-modal-failure.48459e95.svg";